// ── CAPR S5 — the review indicator: a chip for a control whose review is due soon or overdue ──────
//
// ⚠ IT RENDERS THE SERVER'S LABEL, AND NOTHING ELSE. `label` is the S3 resolver's review_label, already
//   in the list row and the Hub payload; this component computes no date and compares no day. The words
//   are CTS_REVIEW_LABEL_TEXT — the deployed vocabulary — so the chip cannot say anything the Review column
//   does not. It is an indicator, PASSIVE by design: no notification, alert or call-to-action wording.
// ⚠ Only the two time-pressed labels get a chip; "current", "not yet assessed" and "no scheduled review"
//   are states, not something to flag, and render nothing.

import { CTS_REVIEW_LABEL_TEXT, type CtsReviewLabel } from '@grc/shared';
import { cn } from '@/lib/utils';

export const REVIEW_CHIP_LABELS: readonly CtsReviewLabel[] = ['overdue', 'due_soon'];

const CHIP_TONE: Record<string, string> = {
  overdue: 'border-cert-expired-border bg-cert-expired-bg text-cert-expired-fg',
  due_soon: 'border-cert-warn-border bg-cert-warn-bg text-cert-warn-fg',
};

export function ReviewDueChip({ label, className }: { label: CtsReviewLabel; className?: string }) {
  if (!REVIEW_CHIP_LABELS.includes(label)) return null;
  const text = CTS_REVIEW_LABEL_TEXT[label];
  return (
    <span
      data-testid="review-due-chip"
      data-label={label}
      aria-label={`Review: ${text}`}
      className={cn('inline-flex shrink-0 items-center rounded-full border px-[7px] py-[1px] text-[10.5px] font-medium', CHIP_TONE[label], className)}
    >
      {text}
    </span>
  );
}
